<div class="fixed flex h-full p-3" style="border-right: 1px solid darkgray; width: 280px">sidenav</div>
